import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, usePageMeta } from "@/lib/api";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/ProductCard";
import { CookieBanner } from "@/components/CookieBanner";
import { SearchX } from "lucide-react";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  usePageMeta(`Resultados para «${q}» · solsdiarias360`, "Busca productos prácticos por nombre, problema o categoría en solsdiarias360.");

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { q, limit: 200 } })
      .then((r) => setProducts(r.data.products))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="App">
      <Header />
      <main className="bg-slate-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="text-amber-600 font-mono-s360 text-xs uppercase tracking-[0.22em] mb-2">Búsqueda</p>
          <h1 className="font-display text-3xl font-extrabold text-slate-900 tracking-tight" data-testid="search-title">
            Resultados para «{q}»
          </h1>
          <p className="text-sm text-slate-600 mt-2" data-testid="search-count">
            {loading ? "Buscando..." : `${products.length} ${products.length === 1 ? "producto encontrado" : "productos encontrados"}`}
          </p>

          {!loading && products.length === 0 ? (
            <div className="flex flex-col items-center py-20 text-center" data-testid="search-empty">
              <SearchX size={40} className="text-slate-300 mb-4" />
              <p className="text-slate-700 font-semibold">No hemos encontrado nada para «{q}»</p>
              <p className="text-slate-500 text-sm mt-2">Prueba con otra palabra o explora las categorías.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-10">
              {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
            </div>
          )}
        </div>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
